export default __webpack_public_path__ + "b78278a0226462b92f2b53d09e52d639.png";